module.exports = __webpack_public_path__ + "static/media/Construction-Projet-Immobilier-Vaud.2e5dba6d.jpg";